import { css } from 'linaria';

export const adplatformTrainingFirstStepSectionTitle = css`
  && {
    @media (--only-desktop) {
      width: 524px;
    }

    @media (--to-desktop) {
      width: 442px;
      font-size: 22px;
      line-height: 28px;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;

export const adplatformTrainingFirstStepSectionButton = css`
  && {
    @media (--only-mobile) {
      width: 100%;
      padding: 10px;
    }
  }
`;
